<form name="userForm" class="form">
     <div *ngFor="let pref of searchPrefs">
     	<div *ngIf="internationalPrefs.includes(pref.name)" class="form-group row">
	         <div class="col-xs-5 control-label"> {{pref.displayName}} </div>
	         <div class="col-xs-7">
	             <input 
	             	*ngIf="pref.name != 'CL_EXPANSION_LANGUAGE_PROPERTY' && pref.name != 'USER_INTERFACE_DATE_TYPE' && (!pref.optionElementList || pref.optionElementList.length == 0)"
	             	type="text" 
	             	[(ngModel)]="pref.value"
	                [id]="pref.name"
	            	[name]="pref.name" 
	            	class="form-control" />
	             
	             <div class="form-horizontal" *ngIf="pref.name == 'USER_INTERFACE_DATE_TYPE'">
	                 <em>{{LOCALIZATION.example}}: {{date_sample}}</em>
	                 <br>
	                 <div class="form-group">
	                     <div class="col-xs-12">	                    
				            <select 
							  [(ngModel)]="date_format"
				              id="date_format_selector"
				              name="date_format"				  
							  class="form-control"
							  (change)="updateDateSample()">
							  <option *ngFor="let option of default_date_formats" [value]="option.value">
							    {{ option.name }}
							  </option>
							</select>	                           
	                     </div>
	                 </div>
	                 <div class="form-group">
	                     <div class="col-xs-12">
	                     	<input 
	                     		type="text" 
	                     		class="form-control" 
	                     		[(ngModel)]="date_format" 
				              	id="date_format_input"
				              	name="date_format"	                     		
	                     		(change)="updateDateSample()" />
	                     </div>
	                 </div>
	                 <label class="control control--checkbox" style="display: inline">
	                    <input 
	                    	type="checkbox" 
	                    	[(ngModel)]="include_date_timestamp" 
	                    	id="date_format_timestamp"
	                    	name="date_format_timestamp"
	                    	(change)="updateDateSample()" />
	                    <div class="control__indicator"></div>
	                </label>
	                <span>{{LOCALIZATION.timestampInclude}}</span>
	                <br>
	                <p><em>Refer to the <a href= "~/../app/load/help/en/help.html#dateformat" target="_blank">help</a> page for more information</em></p>
	            </div>
	            
	            <label *ngIf="pref.name === 'CL_EXPANSION_LANGUAGE_PROPERTY' && (!pref.optionElementList || pref.optionElementList.length == 0)">{{LOCALIZATION.notAvailable}}</label>
	            <ol *ngIf="pref.name === 'CL_EXPANSION_LANGUAGE_PROPERTY'">
	                <li *ngFor="let option of CL_EXPANSION_LANGUAGE_PROPERTY">
	                    <label>
	                        <input type="checkbox" (checked)="option.selected" checklist-value="option.value" [(ngModel)]="option.selected" name="{{option.name}}"> {{option.name}}
	                    </label>
	                </li>
	            </ol>

	            <select 
				  *ngIf="pref.optionElementList?.length && pref.name !== 'CL_EXPANSION_LANGUAGE_PROPERTY'" 
				  [(ngModel)]="pref.value"
	              [id]="pref.name"
	              [name]="pref.name"				  
				  class="form-control">
				  <option *ngFor="let option of pref.optionElementList" [value]="option.value">
				    {{ option.name }}
				  </option>
				</select>
	        </div>
        </div>
    </div>
    <br>
   	<button 
   		type="submit" 
   		class="btn btn-primary pull-right" 
   		(click)="updatePreferences()" 
   		title="Update search preferences">
   			{{LOCALIZATION.update}}
   	</button>
</form>